import { useApplicationContext } from "contexts/ApplicationContext";
import { Use3cPlusConnectionParams } from "contexts/types/context-3cplus-types";
import { stompManager } from "services/3cplus/stomp-manager";
import { getToken } from "Session";
import { stomp3cPlusEvents } from "./3cplus-events";
import { Client } from "@stomp/stompjs";

// Connection Part
export const use3cPlusWSConnection = ({
  dispatch3cPlus,
}: Use3cPlusConnectionParams) => {
  const {
    user: { userData },
  } = useApplicationContext();
  const [user, pass] = window.atob(getToken()! || "")?.split(":");

  if (userData.enabled3cplus) {
    // initialize client singleton (idempotent)
    stompManager.init(
      { login: user, passcode: pass },
      process.env.REACT_APP_PUBLIC_ATTENDANCE_WEBSOCKET || "",
      () => {
        // no-op hook
      }
    );

    // register all events (idempotent)
    stomp3cPlusEvents.forEach(({ eventType, callback }) => {
      stompManager.registerTopic(
        eventType,
        (message, ctx) => {
          // dispatch status and call original callback
          const eventName = eventType.split("/").splice(-1)[0];
          ctx.dispatch3cPlus({ type: "setStatus", payload: eventName });
          console.log(eventName);
          callback(message, { dispatch3cPlus: ctx.dispatch3cPlus });
        },
        dispatch3cPlus
      );
    });
  }

  // return a lightweight reference (not the raw stompjs client) so callers can still interact if needed
  return stompManager as unknown as Client | null;
};
